module.exports = "//static.hsappstatic.net/cms-free-branding-lib/static-1.2/css/hsCmsFreeBranding.css"